import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Button, SvgIcon } from '@mui/material';
import Circle from '../../Helpers/Circles/Circle';
import UsersIcon from '../../../icons/users.svg?react';
import ChartTrendingIcon from '../../../icons/chart-trending.svg?react';
import DollarTagIcon from '../../../icons/dollar-tag.svg?react';
import './CostlyMistakes.scss';

export default function CostlyMistakes() {

  const iconContent =
    [{
      name: "101 Million",
      text: "American adults are in need of life insurance - or more of it.",
      icon: UsersIcon,
      source: "- Life Happens and LIMRA 2023"
    },
    {
      name: "76% Of People",
      text: "Overestimate the cost of a life insurance policy.",
      icon: ChartTrendingIcon,
      source: "- Life Happens and LIMRA 2023"
    },
    {
      name: "69% Of People",
      text: "Will use long-term care services at some point ranging in cost from $19,500 per year for adult day care, to $102,000 for a private room in a nursing home.",
      icon: DollarTagIcon,
      source: "- U.S. Department of Health and Human Services, and Genworth’s Cost of Care Survey"
    }
    ];
  return (
    <Row className="costly-mistakes justify-content-center">
      <Col className="content-section">
        <Circle size="large" />
        <Row className={`icons iconOutline`}>
          {iconContent.map((content, index) =>
            <Col sm key={index} className="point">
              <Row className="d-flex align-items-center justify-content-center">
                <div className="icon-wrapper"><SvgIcon component={content.icon} className="icon" /></div>
              </Row>
              <Row className="d-flex align-items-center justify-content-center">
                <h2 className='px-0'>{content.name}</h2>
                <p className='px-0'>{content.text}</p>
                <div className="source px-0">{content.source}</div>
              </Row>
            </Col>
          )}
        </Row>
        <Row className="info justify-content-center">
          <h2>Buying insurance is easier than you think</h2>
          <p>Simply tell us a little about your needs, and we’ll show you quotes from leading carriers.</p>
          <Button color="primary" variant="outlined" size="large" className="btn-wide-sm" href="#product-tiles" sx={{ padding: '7px 21px !important' }}>Get a Quote</Button>
        </Row>
      </Col>

    </Row >
  );
}
